"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interactionUpdateType = exports.interactionUpdate = exports.interactionSuccess = exports.interactionSubFolderList = exports.interactionSoftDeleteListFolder = exports.interactionSoftDeleteList = exports.interactionSoftDeleteBulk = exports.interactionSoftDelete = exports.interactionRestoreFolder = exports.interactionRestoreBulkFolder = exports.interactionRestoreBulk = exports.interactionRestore = exports.interactionReset = exports.interactionIPFolderUpdate = exports.interactionIPFolderFetch = exports.interactionIPFolderDeleteSoftBulk = exports.interactionIPFolderDeleteSoft = exports.interactionIPFolderDeleteBulk = exports.interactionIPFolderDelete = exports.interactionIPFolderAdd = exports.interactionHardDelete = exports.interactionFinalUpdate = exports.interactionFinalSave = exports.interactionFetchList = exports.interactionFetch = exports.interactionError = exports.interactionDownloadResponse = exports.interactionDeleteBulk = exports.interactionCreate = void 0;
var _interaction = require("./interaction.constant");
// @flow

// common success
var interactionSuccess = function interactionSuccess(actionType, data) {
  return {
    type: _interaction.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.interactionSuccess = interactionSuccess;
var interactionError = function interactionError(actionType, error) {
  return {
    type: _interaction.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * interaction reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.interactionError = interactionError;
var interactionReset = function interactionReset(data) {
  return {
    type: _interaction.actionTypes.RESET,
    payload: data
  };
};

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
exports.interactionReset = interactionReset;
var interactionCreate = function interactionCreate(data) {
  return {
    type: _interaction.actionTypes.CREATE,
    payload: data
  };
};

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 */
exports.interactionCreate = interactionCreate;
var interactionUpdate = function interactionUpdate(data) {
  return {
    type: _interaction.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
exports.interactionUpdate = interactionUpdate;
var interactionFetch = function interactionFetch(data) {
  return {
    type: _interaction.actionTypes.FETCH,
    payload: data
  };
};

/**
 * FetchList
 * @param payload
 * @returns api response
 * @description this function used to FetchList.
 */
exports.interactionFetch = interactionFetch;
var interactionFetchList = function interactionFetchList(data) {
  return {
    type: _interaction.actionTypes.FETCH_LIST,
    payload: data
  };
};

/**
 * SoftDelete
 * @param payload
 * @returns api response
 * @description this function used to SoftDelete.
 */
exports.interactionFetchList = interactionFetchList;
var interactionSoftDelete = function interactionSoftDelete(data) {
  return {
    type: _interaction.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * HardDelete
 * @param payload
 * @returns api response
 * @description this function used to HardDelete.
 */
exports.interactionSoftDelete = interactionSoftDelete;
var interactionHardDelete = function interactionHardDelete(data) {
  return {
    type: _interaction.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
exports.interactionHardDelete = interactionHardDelete;
var interactionRestore = function interactionRestore(data) {
  return {
    type: _interaction.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * SoftDeleteList
 * @param payload
 * @returns api response
 * @description this function used to SoftDeleteList.
 */
exports.interactionRestore = interactionRestore;
var interactionSoftDeleteList = function interactionSoftDeleteList(data) {
  return {
    type: _interaction.actionTypes.SOFT_DELETE_LIST,
    payload: data
  };
};

/**
 * SoftDeleteBulk
 * @param payload
 * @returns api response
 * @description this function used to SoftDeleteBulk.
 */
exports.interactionSoftDeleteList = interactionSoftDeleteList;
var interactionSoftDeleteBulk = function interactionSoftDeleteBulk(data) {
  return {
    type: _interaction.actionTypes.SOFT_DELETE_BULK,
    payload: data
  };
};

/**
 * DeleteBulk
 * @param payload
 * @returns api response
 * @description this function used to DeleteBulk.
 */
exports.interactionSoftDeleteBulk = interactionSoftDeleteBulk;
var interactionDeleteBulk = function interactionDeleteBulk(data) {
  return {
    type: _interaction.actionTypes.DELETE_BULK,
    payload: data
  };
};

/**
 * RestoreBulk
 * @param payload
 * @returns api response
 * @description this function used to RestoreBulk.
 */
exports.interactionDeleteBulk = interactionDeleteBulk;
var interactionRestoreBulk = function interactionRestoreBulk(data) {
  return {
    type: _interaction.actionTypes.RESTORE_BULK,
    payload: data
  };
};

/**
 * FinalSave
 * @param payload
 * @returns api response
 * @description this function used to FinalSave.
 */
exports.interactionRestoreBulk = interactionRestoreBulk;
var interactionFinalSave = function interactionFinalSave(data) {
  return {
    type: _interaction.actionTypes.FINAL_SAVE,
    payload: data
  };
};

/**
 * FinalUpdate
 * @param payload
 * @returns api response
 * @description this function used to FinalUpdate.
 */
exports.interactionFinalSave = interactionFinalSave;
var interactionFinalUpdate = function interactionFinalUpdate(data) {
  return {
    type: _interaction.actionTypes.FINAL_UPDATE,
    payload: data
  };
};

/**
 * Sub folder list
 * @param payload
 * @returns api response
 * @description this function used to SubFolderList.
 */
exports.interactionFinalUpdate = interactionFinalUpdate;
var interactionSubFolderList = function interactionSubFolderList(data) {
  return {
    type: _interaction.actionTypes.SUB_FOLDER_LIST,
    payload: data
  };
};

/**
 * Download response
 * @param payload
 * @returns api response
 * @description this function used to Download Response.
 */
exports.interactionSubFolderList = interactionSubFolderList;
var interactionDownloadResponse = function interactionDownloadResponse(data) {
  return {
    type: _interaction.actionTypes.DOWNLOAD_RESPONSE,
    payload: data
  };
};

/**
 * Download response cp
 * @param payload
 * @returns api response
 * @description this function used to Download Response Cp.
 */
exports.interactionDownloadResponse = interactionDownloadResponse;
var interactionUpdateType = function interactionUpdateType(data) {
  return {
    type: _interaction.actionTypes.DOWNLOAD_RESPONSE_CP,
    payload: data
  };
};

/**
 * IP folder fetch
 * @param payload
 * @returns api response
 * @description this function used to IP folder fetch.
 */
exports.interactionUpdateType = interactionUpdateType;
var interactionIPFolderFetch = function interactionIPFolderFetch(data) {
  return {
    type: _interaction.actionTypes.IP_FOLDER_FETCH,
    payload: data
  };
};

/**
 * IP folder add
 * @param payload
 * @returns api response
 * @description this function used to IP folder add.
 */
exports.interactionIPFolderFetch = interactionIPFolderFetch;
var interactionIPFolderAdd = function interactionIPFolderAdd(data) {
  return {
    type: _interaction.actionTypes.IP_FOLDER_ADD,
    payload: data
  };
};

/**
 * IP folder update
 * @param payload
 * @returns api response
 * @description this function used to IP folder update.
 */
exports.interactionIPFolderAdd = interactionIPFolderAdd;
var interactionIPFolderUpdate = function interactionIPFolderUpdate(data) {
  return {
    type: _interaction.actionTypes.IP_FOLDER_UPDATE,
    payload: data
  };
};

/**
 * IP folder delete
 * @param payload
 * @returns api response
 * @description this function used to IP folder delete.
 */
exports.interactionIPFolderUpdate = interactionIPFolderUpdate;
var interactionIPFolderDelete = function interactionIPFolderDelete(data) {
  return {
    type: _interaction.actionTypes.IP_FOLDER_DELETE,
    payload: data
  };
};

/**
 * IP folder delete bulk
 * @param payload
 * @returns api response
 * @description this function used to IP folder delete bulk.
 */
exports.interactionIPFolderDelete = interactionIPFolderDelete;
var interactionIPFolderDeleteBulk = function interactionIPFolderDeleteBulk(data) {
  return {
    type: _interaction.actionTypes.IP_FOLDER_DELETE_BULK,
    payload: data
  };
};

/**
 * IP folder delete soft
 * @param payload
 * @returns api response
 * @description this function used to IP folder delete soft.
 */
exports.interactionIPFolderDeleteBulk = interactionIPFolderDeleteBulk;
var interactionIPFolderDeleteSoft = function interactionIPFolderDeleteSoft(data) {
  return {
    type: _interaction.actionTypes.IP_FOLDER_DELETE_SOFT,
    payload: data
  };
};

/**
 * IP folder delete soft bulk
 * @param payload
 * @returns api response
 * @description this function used to IP folder delete soft bulk.
 */
exports.interactionIPFolderDeleteSoft = interactionIPFolderDeleteSoft;
var interactionIPFolderDeleteSoftBulk = function interactionIPFolderDeleteSoftBulk(data) {
  return {
    type: _interaction.actionTypes.IP_FOLDER_DELETE_SOFT_BULK,
    payload: data
  };
};

/**
 * SoftDeleteListFolder
 * @param payload
 * @returns api response
 * @description this function used to SoftDeleteListFolder.
 */
exports.interactionIPFolderDeleteSoftBulk = interactionIPFolderDeleteSoftBulk;
var interactionSoftDeleteListFolder = function interactionSoftDeleteListFolder(data) {
  return {
    type: _interaction.actionTypes.SOFT_DELETE_LIST_FOLDER,
    payload: data
  };
};

/**
 * RestoreFolder
 * @param payload
 * @returns api response
 * @description this function used to RestoreFolder.
 */
exports.interactionSoftDeleteListFolder = interactionSoftDeleteListFolder;
var interactionRestoreFolder = function interactionRestoreFolder(data) {
  return {
    type: _interaction.actionTypes.RESTORE_FOLDER,
    payload: data
  };
};

/**
 * RestoreBulkFolder
 * @param payload
 * @returns api response
 * @description this function used to RestoreBulkFolder.
 */
exports.interactionRestoreFolder = interactionRestoreFolder;
var interactionRestoreBulkFolder = function interactionRestoreBulkFolder(data) {
  return {
    type: _interaction.actionTypes.RESTORE_BULK_FOLDER,
    payload: data
  };
};
exports.interactionRestoreBulkFolder = interactionRestoreBulkFolder;